# CLI reference

Auto-generated from `@cairntools/cli`. Every command + flag the binary accepts is listed below.

> This page is regenerated on every build. Add or change a command in `cli/src/index.js`, not this file.

## `cairn`

Cairn CLI — graph-driven testing for your app.

Version: `0.1.1`

## `cairn init`

Initialize Cairn in this repo (writes .graphs/.config.yaml).

```bash
cairn init [options]
```

**Options:**

- `-p, --project-id <id>` — cairn_proj_<id> from the dashboard
- `-t, --team-id <id>` — team_<id> from the dashboard
- `-d, --dev-url <url>` — dev environment URL
- `--force` — overwrite an existing .graphs/.config.yaml

## `cairn login`

Sign in to Cairn via browser-based Firebase Auth.

```bash
cairn login [options]
```

## `cairn logout`

Clear local Cairn credentials.

```bash
cairn logout [options]
```

## `cairn whoami`

Show the currently signed-in user.

```bash
cairn whoami [options]
```

## `cairn validate`

Schema-check all .graphs/*.yaml.

```bash
cairn validate [options]
```

## `cairn record`

Record a voice walkthrough → flow YAML (opens a browser tab).

```bash
cairn record [options] <flow>
```

**Options:**

- `--force` — overwrite an existing .graphs/<flow>.yaml without prompting

## `cairn run`

Execute a flow.

```bash
cairn run [options] <flow>
```

**Options:**

- `-e, --env <env>` — environment name (matches flow.spec.envs) *(default: `dev`)*
- `-r, --reporter <kind>` — console | json *(default: `console`)*

## `cairn compile`

Emit framework test code from a flow YAML.

```bash
cairn compile [options] <flow>
```

**Options:**

- `-t, --target <framework>` — playwright (V1); cypress/webdriverio V1.5+ *(default: `playwright`)*
- `-o, --out-dir <dir>` — output directory (default: tests/generated)
- `-e, --env <env>` — environment name (matches flow.spec.envs) *(default: `dev`)*

## `cairn scan`

Detect drift between .graphs/*.yaml and your code.

```bash
cairn scan [options]
```

## `cairn accept`

Apply suggested drift patches from .graphs/.cache/suggestions/.

```bash
cairn accept [options] <flow>
```

**Options:**

- `--all-high` — apply every patch with confidence ≥ 0.9
- `--force` — apply every patch regardless of confidence

## `cairn edit`

Open the flow YAML in $EDITOR; auto-validates on exit.

```bash
cairn edit [options] <flow>
```

## `cairn diff`

Structural diff between two flow YAMLs (paths or git-ref:path).

```bash
cairn diff [options] <a> <b>
```
